<template>
  <ToastNotificationListItem
    v-if="isImpersonated"
    type="persistent"
    :message="[
      'Impersonating ',
      {
        text: name,
        bold: true
      }
    ]"
    class="bg-warning text-black px-md">
    <template #link>
      <BaseButton
        text="Stop"
        to="/impersonate/stop/"
        class="bg-danger"/>
    </template>
  </ToastNotificationListItem>
</template>

<script setup>
import ToastNotificationListItem from '@/components/global/ToastNotificationListItem.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { useClientStore } from '@shared/stores/client.js'
import { storeToRefs } from 'pinia'

const { name, isImpersonated } = storeToRefs(useClientStore())

</script>

<style lang="scss" scoped>
.toast-notification {
  padding: $spacing-xs $spacing-lg !important;
  grid-template-columns: 1fr auto;

  :deep(.icon) {
    display: none !important;
  }
  .base-button {
    height: 28px;
  }
}
</style>
